// extracted by mini-css-extract-plugin
export default {"TableEmptyState":"TableEmptyState_TableEmptyState__TFIB+","hasTopPadding":"TableEmptyState_hasTopPadding__ChnUZ"};